import React, { useEffect, useState } from 'react'
import Api from '../../../../_helpers/Api'
import Skeleton from 'react-loading-skeleton'
import '../../../../assets/css/partials/TodosStatsPerEmployee.css'
import { BarChart } from '@mui/x-charts'

export default function TodosStatsPerEmployee({
    endpoint = 'dashboard/todos-stats-per-employee',
    title = 'Бележки'
}) {
    const [state, setState] = useState({ loading: true, data: null })

    const statusColors = {
        awaiting: '#22C55E',
        completed: '#3B82F6',
        fail: '#8B5CF6'
    }

    const statusLabels = {
        awaiting: 'Изчакващи',
        completed: 'Завърш',
        fail: 'Незавърш'
    }

    useEffect(() => {
        Api.get(endpoint)
            .then(res => {
                const payload = res?.data ?? res

                setState({ loading: false, data: payload })
            })
            .catch(() => {
                setState({ loading: false, data: null })
            })
    }, [endpoint])

    const employeeData = Array.isArray(state.data) ? state.data : []

    const chartData = employeeData.map(emp => ({
        employee: emp.employee,
        awaiting: emp.awaiting || 0,
        completed: emp.completed || 0,
        fail: emp.fail || 0
    }))

    const valueFormatter = (value) => `${value}`

    return (
        <div className="todos-stats-chart">
            <div className="head">
                <h3>{title}</h3>
                <ul>
                    {Object.entries(statusLabels).map(([status, label]) => (
                        <li key={status}>
                            <span
                                style={{ backgroundColor: statusColors[status] }}
                            />
                            {label}
                        </li>
                    ))}
                </ul>
            </div>
            <hr />
            {state.loading ?
                <Skeleton height={300} count={1} />
                :
                <BarChart
                    dataset={chartData}
                    xAxis={[{
                        scaleType: 'band',
                        dataKey: 'employee'
                    }]}
                    series={[
                        {
                            dataKey: 'awaiting',
                            label: statusLabels.awaiting,
                            valueFormatter,
                            color: statusColors.awaiting
                        },
                        {
                            dataKey: 'completed',
                            label: statusLabels.completed,
                            valueFormatter,
                            color: statusColors.completed
                        },
                        {
                            dataKey: 'fail',
                            label: statusLabels.fail,
                            valueFormatter,
                            color: statusColors.fail
                        }
                    ]}
                    height={400}
                    margin={{
                        right: 0
                    }}
                    slotProps={{
                        legend: { hidden: true }
                    }}
                    borderRadius={4}
                />
            }
        </div>
    )
}